import React from 'react'

import {
    ErrorBox,
    FormHeader,
    FormSubtitle,
    FormTitle,
    Panel,
    RightCell,
    StateBox,
    Table,
    TableWrapper,
    ViewButton,
} from '../../style'
import { useHistoryExportsList } from './useHistoryExportsList'

const HistoryExportsList = () => {
    const {
        exports,
        exportsLoading,
        exportsError,
        formatDate,
        formatSize,
        handleDownloadExport,
    } = useHistoryExportsList()

    return (
        <Panel>
            <FormHeader>
                <div>
                    <FormTitle>Сохранённые экспорты</FormTitle>
                    <FormSubtitle>
                        Файлы расписания, сохранённые на сервере
                    </FormSubtitle>
                </div>
            </FormHeader>

            {exportsError && <ErrorBox>{exportsError}</ErrorBox>}

            {exportsLoading ? (
                <StateBox>Загрузка...</StateBox>
            ) : exports.length === 0 ? (
                <StateBox>Пока нет сохранённых экспортов</StateBox>
            ) : (
                <TableWrapper>
                    <Table>
                        <thead>
                            <tr>
                                <th>Группа</th>
                                <th>Дата</th>
                                <th>Размер</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {exports.map((item) => (
                                <tr key={item.key}>
                                    <td>{item.group || '—'}</td>
                                    <td>{formatDate(item.created_at, true)}</td>
                                    <td>{formatSize(item.size)}</td>
                                    <RightCell>
                                        <ViewButton
                                            type="button"
                                            onClick={() => handleDownloadExport(item)}
                                        >
                                            Скачать
                                        </ViewButton>
                                    </RightCell>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </TableWrapper>
            )}
        </Panel>
    )
}

export default HistoryExportsList
